/**
 * Select component type definitions
 */

export enum SelectSize {
  Small = 'sm',
  Default = 'default',
  Large = 'lg',
}

export enum SelectVariant {
  Default = 'default',
  Error = 'error',
  Success = 'success',
}
